import { State } from 'model/State';
import { selectSwitchedUser } from '../selectors';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { postToHamsClient } from 'util/mac/api/order/post';

export const searchForContact = (
  state: State,
  maxResultsParam: number,
  offsetParam: number,
  orderNumberMask?: number,
  technicalContactCompanyDomainName?: string,
  integerPartOfTotalAmount?: number,
) => {
  const email = selectSwitchedUser(state);

  return fetchWithParamValidation(
    ({ maxResults, offset }) =>
      postToHamsClient(
        'searchForContact',
        state,
        {
          maxResults,
          offset,
        },
        {
          email,
          orderNumberMask,
          technicalContactCompanyDomainName,
          integerPartOfTotalAmount,
        },
      ),
    { maxResults: maxResultsParam, offset: offsetParam },
  );
};

export const singleSearchForContact = (orderNumberMask, state: State) => {
  const email = selectSwitchedUser(state);

  return fetchWithParamValidation(
    ({ maxResults, offset }) =>
      postToHamsClient(
        'searchForContact',
        state,
        {
          maxResults,
          offset,
        },
        {
          email,
          orderNumberMask,
        },
      ),
    { maxResults: 1, offset: 0 },
  );
};
